/**
 * Forte Plus — utánvétes rendelés a kosárból.
 *
 * 1) A kosár „Rendelés utánvéttel” gombja (snippets/cart-summary.liquid) nem a Shopify
 *    pénztárba visz, hanem a Releasit utánvét űrlapot nyitja meg a teljes kosárral. Ugyanazt
 *    teszi, mint a Releasit saját kosár-gombja: beolvassa a valódi Shopify kosarat
 *    (Storefront cart id = a /cart.js token), és azt adja az űrlap állapotának. A kosárba nem ír,
 *    a csomagkedvezményt (Shopify Function) így az űrlap is látja.
 * 2) A /cart oldal átirányít (layout/theme.liquid) és jelzést hagy: itt kinyílik a kosár-fiók.
 */
(() => {
  if (window.__epCodCheckout) return;
  window.__epCodCheckout = true;

  const OPEN_DRAWER_FLAG = 'ep:open-cart-drawer';

  const waitFor = (probe, timeout = 8000, step = 150) =>
    new Promise((resolve, reject) => {
      const started = Date.now();
      const tick = () => {
        const value = probe();
        if (value) return resolve(value);
        if (Date.now() - started >= timeout) return reject(new Error('Releasit is not ready'));
        setTimeout(tick, step);
      };
      tick();
    });

  const releasitApi = () => {
    const api = window._rsiV2;
    const ready =
      api &&
      typeof api.getState === 'function' &&
      typeof api.setState === 'function' &&
      api.cartService &&
      typeof api.cartService.getCart === 'function';
    return ready ? api : null;
  };

  const numericId = (gid) => (gid ? Number(String(gid).split('/').pop()) : undefined);

  async function openCodForm() {
    const api = await waitFor(releasitApi);
    if (api.getState()?.isOpen) return;

    // Ajándék (assets/ep-gift.js): az űrlap csak stabil kosárra nyílhat, amelyben az ajándék már benne
    // van, ha jár — különben a sorok és a kedvezmény eltérhetnek (0 € végösszegű rendelés, Lengyelország).
    const cart = window.__epGift
      ? await window.__epGift.settled()
      : await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then((r) => r.json());
    if (!cart.item_count) throw new Error('The cart is empty');

    const result = await api.cartService.getCart(`gid://shopify/Cart/${cart.token}`);
    const cartInfo = result?.data?.cart;
    const edges = cartInfo?.lines?.edges || [];
    if (!edges.length) throw new Error('Releasit could not read the cart');

    const first = edges[0].node.merchandise;
    api.setState({
      cartInfo,
      products: edges.map((edge) => edge.node.merchandise),
      currentVariantId: numericId(first?.id),
      currentProductId: numericId(first?.product?.id),
      triggerCartUpdate: 0,
      isOpen: true,
      isCartButtonLoading: false,
      isClearingCart: false,
    });
  }

  // Az ajándék termékoldali útvonala is ezen keresztül nyitja az űrlapot (assets/ep-gift.js).
  window.epOpenCodForm = openCodForm;

  let opening = null;

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target instanceof Element ? event.target.closest('.cart__checkout-button--cod') : null;
      if (!button) return;
      event.preventDefault();
      if (opening) return;

      button.setAttribute('aria-busy', 'true');
      document.getElementById('cart-drawer')?.close?.();

      opening = openCodForm()
        .catch((error) => {
          // Utolsó védővonal: ha a Releasit nem érhető el, a vevő ne ragadjon egy halott gombon.
          console.warn('[ep-cod] Could not open the COD form, continuing to checkout:', error);
          window.location.href = '/checkout';
        })
        .finally(() => {
          opening = null;
          button.removeAttribute('aria-busy');
        });
    },
    true
  );

  try {
    if (sessionStorage.getItem(OPEN_DRAWER_FLAG)) {
      sessionStorage.removeItem(OPEN_DRAWER_FLAG);
      customElements.whenDefined('theme-drawer').then(() => document.getElementById('cart-drawer')?.open?.());
    }
  } catch (error) {
    // A sessionStorage letiltható (privát mód) – ilyenkor egyszerűen nem nyílik ki a fiók.
  }
})();
